import { Component, Input, Output, EventEmitter } from '@angular/core';
import { InspectionSection } from '../../shared/models/index';
@Component({
    selector: 'section-list-table',
    templateUrl: './list.component.html',
    standalone: false
})
export class InspectionSectionListComponent {
  @Input() public sections: InspectionSection[];
  @Output() public toggleSelectSection: EventEmitter<any> = new EventEmitter();
  public selection: any = {};
  errorMessage: string;

  public loading: Boolean = true;

  constructor() {}

  public selectSection(section: InspectionSection) {
    this.toggleSelectSection.emit(section);
  }
}
